<template>
  <div class="nko-company">
    <img
      src="/local/templates/main/img/nko/unilever.png"
      alt=""
      class="nko-company__image"
    >
    <div class="nko-company__block">
      <h3 class="nko-company__name">
        Компания Uniliver
      </h3>
      <p class="nko-company__text">
        Дата регистрации: 22.05.22
      </p>
    </div>
    <div class="nko-company-spent">
      <h6 class="nko-company-spent__title">450</h6>
      <p class="nko-company-spent__text">Выделено часов</p>
    </div>
    <div class="nko-company-spent">
      <h6 class="nko-company-spent__title">10</h6>
      <p class="nko-company-spent__text">Проектов</p>
    </div>
    <ABtn
      v-if="screenWidth >= 768"
      label="Создать заявку"
      class="secondary"
    />
  </div>
</template>

<script>
import { ABtn } from "../ui";

export default {
  name: 'NkoCompany',
  props: ['result'],
  components: {
    ABtn,
  }
}
</script>

<style lang="scss" scoped>
.nko-company {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: absolute;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  @include tablet{
    grid-template-columns: 76px auto repeat(3, auto);
    grid-column-gap: 30px;
    align-items: center;
    position: static;
    box-shadow: unset;
  }
  @include mobile{
    grid-template-columns: repeat(2, 1fr);
  }
  &__image{
    max-width: 125px;
    margin: 41px auto 30px;
    grid-column-start: 1;
    grid-column-end: 3;
    @include tablet{
      align-items: center;
      grid-column-start: unset;
      grid-column-end: unset;
      max-width: 76px;
      margin: 0;
    }
    @include mobile{
      grid-column-start: 1;
      grid-column-end: 3;
      margin: 0 auto 30px;
    }
  }
  &__block{
    grid-column-start: 1;
    grid-column-end: 3;
    @include tablet{
      grid-column-start: unset;
      grid-column-end: unset;
    }
    @include mobile{
      grid-column-start: 1;
      grid-column-end: 3;
    }
  }
  &__name{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    color: #252425;
    margin-bottom: 12px;
    @include tablet{
      margin-bottom: 6px;
      text-align: start;
    }
    @include mobile{
      margin-bottom: 9px;
      text-align: center;
    }
  }
  &__text{
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #87929D;
    margin-bottom: 43px;
    text-align: center;
    @include tablet{
      margin-bottom: 0;
      text-align: start;
    }
    @include mobile{
      text-align: center;
    }
  }
  :deep{
    .a-btn{
      grid-column-start: 1;
      grid-column-end: 3;
      border-top-right-radius: unset;
      border-top-left-radius: unset;
      border: unset;
      @include tablet{
        grid-column-start: unset;
        grid-column-end: unset;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
      }
      @include mobile{
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
  }
}
.nko-company-spent{
  border-top: 1px solid #E9EBED;
  padding: 20px 0;
  border-right: 1px solid #E9EBED;
  @include tablet{
    border-top: unset;
    border-right: unset;
  }
  &__title{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    text-align: center;
    color: #252425;
    @include tablet{
      text-align: start;
    }
    @include mobile{
      text-align: center;
    }
  }
  &__text{
    font-size: 14px;
    line-height: 19px;
    color: #87929D;
    text-align: center;
    margin-bottom: 0;
    @include tablet{
      text-align: start;
    }
    @include mobile{
      text-align: center;
    }
  }
}
</style>